// ============================================================
// Document Templates — plain HTML for TipTap editor
// ============================================================
//
// Each template has:
//   id             — unique identifier
//   name           — display name
//   description    — short description shown in template picker
//   defaultSubject — default email subject when sending
//   defaultContent — HTML loaded into TipTap editor
//
// Templates are tenant-aware via getDocTemplates(tenant).

export function getDocTemplates(tenant) {
  const companyName = tenant.companyName || "Fordham Global Foresight";

  return [
    {
      id: "blank",
      name: "Blank Document",
      description: "Start from scratch with a blank document.",
      defaultSubject: "",
      defaultContent: "<p>Start writing your document here...</p>",
    },
    {
      id: "proposal",
      name: "Advisory Proposal",
      description: "Engagement proposal with scope, deliverables, and pricing.",
      defaultSubject: `${companyName} — Advisory Engagement Proposal`,
      defaultContent: `<p>Dear {{first_name}},</p>
<p>Thank you for the opportunity to present this advisory engagement proposal. Based on our recent discussions, we have prepared the following scope of work tailored to {{company}}'s requirements.</p>
<h2>Executive Summary</h2>
<p>[Brief overview of the engagement and its objectives]</p>
<h2>Scope of Work</h2>
<h3>Phase 1: Assessment</h3>
<ul>
<li>[Deliverable 1]</li>
<li>[Deliverable 2]</li>
<li>[Deliverable 3]</li>
</ul>
<h3>Phase 2: Strategic Advisory</h3>
<ul>
<li>[Deliverable 1]</li>
<li>[Deliverable 2]</li>
</ul>
<h2>Timeline</h2>
<p>[Estimated timeline for each phase]</p>
<h2>Investment</h2>
<p>[Pricing details and payment terms]</p>
<h2>Next Steps</h2>
<p>We would welcome the opportunity to discuss this proposal in more detail at your convenience.</p>
<p>Warm regards,<br /><strong>${companyName}</strong></p>`,
    },
    {
      id: "briefing",
      name: "Risk Briefing",
      description: "Tailored geopolitical risk briefing for a client.",
      defaultSubject: `${companyName} — Geopolitical Risk Briefing`,
      defaultContent: `<p>Dear {{first_name}},</p>
<p>Please find below your tailored geopolitical risk briefing prepared by ${companyName}.</p>
<h2>Situation Overview</h2>
<p>[Describe the current geopolitical landscape relevant to the client's interests]</p>
<h2>Risk Assessment</h2>
<h3>Political Risk</h3>
<p>[Assessment of political risk factors]</p>
<h3>Economic Risk</h3>
<p>[Assessment of economic risk factors]</p>
<h3>Security Risk</h3>
<p>[Assessment of security risk factors]</p>
<h2>Impact Analysis</h2>
<p>Based on {{company}}'s exposure profile, the following areas warrant attention:</p>
<ul>
<li><strong>[Area 1]:</strong> [Impact assessment]</li>
<li><strong>[Area 2]:</strong> [Impact assessment]</li>
<li><strong>[Area 3]:</strong> [Impact assessment]</li>
</ul>
<h2>Recommendations</h2>
<ol>
<li>[Recommendation 1]</li>
<li>[Recommendation 2]</li>
<li>[Recommendation 3]</li>
</ol>
<p>We remain available for a detailed discussion of these findings.</p>
<p>Best regards,<br /><strong>${companyName}</strong></p>`,
    },
    {
      id: "report",
      name: "Research Report",
      description: "Structured report with methodology, findings, and conclusions.",
      defaultSubject: `${companyName} — Research Report`,
      defaultContent: `<h1>[Report Title]</h1>
<p><em>Prepared by ${companyName}</em></p>
<hr />
<h2>1. Introduction</h2>
<p>[Background and purpose of this research report]</p>
<h2>2. Methodology</h2>
<p>[Describe the analytical framework and data sources used]</p>
<h2>3. Key Findings</h2>
<h3>Finding 1</h3>
<p>[Detailed analysis and supporting evidence]</p>
<h3>Finding 2</h3>
<p>[Detailed analysis and supporting evidence]</p>
<h3>Finding 3</h3>
<p>[Detailed analysis and supporting evidence]</p>
<h2>4. Implications</h2>
<p>[What these findings mean for stakeholders and decision-makers]</p>
<h2>5. Conclusions & Recommendations</h2>
<p>[Summary of key takeaways and actionable recommendations]</p>
<hr />
<p><em>This report is confidential and prepared exclusively for the intended recipient.</em></p>`,
    },
    {
      id: "nda",
      name: "NDA (E-Signature)",
      description: "Send the standard NDA for digital signature via SignWell.",
      isSignwell: true,
      defaultSubject: "",
      defaultContent: "",
    },
    {
      id: "letter",
      name: "Formal Letter",
      description: "Professional correspondence letter.",
      defaultSubject: `Correspondence from ${companyName}`,
      defaultContent: `<p>Dear {{first_name}},</p>
<p>[Body of the letter]</p>
<p>Please do not hesitate to reach out if you have any questions or require further information.</p>
<p>Yours sincerely,</p>
<p><strong>[Name]</strong><br />[Title]<br />${companyName}</p>`,
    },
  ];
}
